export default {
  items: [
    {
      name: 'Dashboard',
      role: {
        and: ['user', 'has_corporation'], // Considera "AND". Retorna falso caso o usuário não possua qualquer dos papeis.
      },
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Corporações',
      role: {
        or: [{ and: ['user', 'has_corporation'] }, 'corporation_manager']
      },
      url: '/corporations',
      icon: 'icon-briefcase',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Grupos Corp.',
      role: {
        or: ['super_admin', 'corporation_manager']
      },
      url: '/corporation-groups',
      icon: 'icon-folder',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Usuários',
      role: {
        and: ['user', 'has_corporation']
      },
      url: '/users',
      icon: 'icon-user',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Grupos Usuários',
      role: {
        and: ['user', 'has_corporation']
      },
      url: '/user-groups',
      icon: 'icon-folder',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Relatórios',
      role: {
        or: [{ and: ['user', 'has_corporation'] }, 'user_retail_manager']
      },
      url: '/reports',
      icon: 'icon-doc',
      badge: {
        variant: 'primary'
      },
      children: [
        {
          name: 'Operações',
          icon: 'icon-library',
          url: '/reports/users-operation',
          role: {
            and: ['user', 'has_corporation']
          }
        },
        {
          name: 'Sem Operações',
          url: '/reports/whithout-operation',
          role: {
            and: ['user', 'has_corporation']
          }
        },
        {
          name: 'Ativações',
          url: '/reports/activations',
          role: {
            and: ['user', 'has_corporation']
          }
        },
        {
          name: 'Usuários Corp.',
          url: '/reports/users',
          role: 'corporation_manager'
        },
        {
          name: 'Compras BirdID',
          url: '/reports/purchase-transactions',
          role: {
            or: ['super_admin', 'user_retail_manager']
          }
        },
      ]
    },
    {
      name: 'Usuários Varejo',
      role: 'user_retail_manager',
      url: '/users-retail',
      icon: 'icon-people',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Administração',
      role: {
        or: ['super_admin', 'support']
      },
      url: '/admin',
      icon: 'icon-settings',
      badge: {
        variant: 'primary'
      },
      children: [
        {
          name: 'Fator de bloqueio',
          role: 'super_admin',
          url: '/admin/lock-factor',
          icon: 'icon-lock',
          badge: {
            variant: 'primary'
          }
        },
        {
          name: 'Logs do utilitário',
          role: 'super_admin',
          url: '/admin/logs-utility',
          icon: 'fa fa-newspaper-o',
          badge: {
            variant: 'primary'
          }
        },
        {
          name: 'Usuário info',
          role: {
            or: ['super_admin', 'support']
          },
          url: '/admin/user-deep-detail',
          icon: 'fa fa-user-circle-o',
          badge: {
            variant: 'primary'
          }
        },
        {
          name: 'Perfis de usuário',
          role: 'super_admin',
          url: '/admin/users-role',
          icon: 'fa fa-drivers-license-o',
          badge: {
            variant: 'primary'
          }
        },
        {
          name: 'Cartões OTP',
          role: 'super_admin',
          url: '/admin/otp-device',
          icon: 'fa fa-credit-card',
          badge: {
            variant: 'primary'
          }
        },
        {
          name: 'Lista de Supressão',
          role: 'super_admin',
          url: '/admin/mail-supression-list',
          icon: 'fa fa-envelope-o',
          badge: {
            variant: 'primary'
          }
        },
        {
          name: 'Log SMS',
          role: 'super_admin',
          url: '/admin/logs-sms',
          icon: 'fa fa-phone',
          badge: {
            variant: 'primary'
          }
        }
      ]
    }
  ]

}
